import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import WhatsAppManager from './WhatsAppManager';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

function WhatsAppSetup() {
  const [status, setStatus] = useState({ instances: [], connected: false });
  const [showManager, setShowManager] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchStatus();
    const interval = setInterval(fetchStatus, 3000);
    return () => clearInterval(interval);
  }, []);

  const fetchStatus = async () => {
    try {
      const res = await fetch(`${API_URL}/api/whatsapp/status`);
      const data = await res.json();
      setStatus(data);
      setLoading(false);
    } catch (e) {
      console.error('Erreur statut WhatsApp:', e);
      setLoading(false);
    }
  };

  const disconnectedInstances = status.instances?.filter(i => !i.connected && i.qrCode) || [];
  const connectedInstances = status.instances?.filter(i => i.connected) || [];
  const pendingInstances = status.instances?.filter(i => !i.connected && !i.qrCode) || [];

  return (
    <div className="whatsapp-setup">
      <h2 style={{ marginBottom: '10px' }}>Configuration WhatsApp</h2>
      <p style={{ color: 'var(--text-muted)', marginBottom: '20px' }}>
        {status.connectedInstances || 0} / {status.totalInstances || 0} numéro(s) connecté(s)
      </p>

      <button
        onClick={() => setShowManager(true)}
        style={{
          padding: '12px 24px',
          background: '#25d366',
          border: 'none',
          borderRadius: '8px',
          color: 'white',
          fontWeight: '600',
          cursor: 'pointer',
          marginBottom: '20px'
        }}
      >
        ⚙️ Gérer les numéros WhatsApp
      </button>

      {loading ? (
        <div className="loading">
          <div className="spinner"></div>
          Chargement...
        </div>
      ) : (
        <>
          {/* QR Codes à scanner */}
          {disconnectedInstances.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ marginBottom: '15px', color: 'var(--warning)' }}>
                📱 QR Codes à scanner
              </h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', justifyContent: 'center' }}>
                {disconnectedInstances.map(instance => (
                  <div
                    key={instance.instanceId}
                    style={{
                      padding: '20px',
                      background: 'white',
                      borderRadius: '12px',
                      textAlign: 'center'
                    }}
                  >
                    <div style={{ color: '#333', fontWeight: '600', marginBottom: '10px' }}>
                      {instance.name}
                    </div>
                    <QRCodeSVG value={instance.qrCode} size={180} />
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Numéros connectés */}
          {connectedInstances.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ marginBottom: '15px', color: '#25d366' }}>
                ✅ Numéros connectés
              </h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                {connectedInstances.map(instance => (
                  <div
                    key={instance.instanceId}
                    style={{
                      padding: '10px 20px',
                      background: 'rgba(37, 211, 102, 0.1)',
                      border: '1px solid #25d366',
                      borderRadius: '8px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                  >
                    <span style={{ color: '#25d366', fontWeight: '600' }}>{instance.name}</span>
                    {instance.phoneNumber && (
                      <span style={{ color: 'var(--text-muted)', fontSize: '0.85rem' }}>
                        +{instance.phoneNumber}
                      </span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* En attente */}
          {pendingInstances.length > 0 && (
            <div style={{ marginBottom: '30px' }}>
              <h3 style={{ marginBottom: '15px', color: 'var(--text-muted)' }}>
                ⏳ En attente
              </h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', justifyContent: 'center' }}>
                {pendingInstances.map(instance => (
                  <div
                    key={instance.instanceId}
                    style={{
                      padding: '10px 20px',
                      background: 'var(--bg-tertiary)',
                      borderRadius: '8px'
                    }}
                  >
                    <span style={{ color: 'var(--text-muted)' }}>{instance.name}</span>
                    <span style={{ marginLeft: '10px' }}>⏳</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Aucune instance */}
          {status.instances?.length === 0 && (
            <div style={{
              padding: '40px',
              textAlign: 'center',
              color: 'var(--text-muted)'
            }}>
              <p>Aucun numéro WhatsApp configuré.</p>
              <p>Cliquez sur "Gérer les numéros WhatsApp" pour en ajouter.</p>
            </div>
          )}
        </>
      )}

      <div style={{
        marginTop: '30px',
        padding: '20px',
        background: 'rgba(251, 191, 36, 0.1)',
        borderRadius: '8px',
        border: '1px solid var(--warning)'
      }}>
        <h4 style={{ color: 'var(--warning)', marginBottom: '10px' }}>
          ⚠️ Avertissement
        </h4>
        <p style={{ color: 'var(--text-secondary)', fontSize: '0.9rem', lineHeight: '1.6' }}>
          L'automation WhatsApp Web peut entraîner un bannissement. Utilisez des numéros dédiés au support.
        </p>
      </div>

      {showManager && <WhatsAppManager onClose={() => setShowManager(false)} />}
    </div>
  );
}

export default WhatsAppSetup;
